module.exports = __webpack_public_path__ + "img/mobilehardwareOpen6.969496de.png";